var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcWhitePhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67963 3.58353L5.55605 2.70711C5.94658 2.31658 6.57974 2.31658 6.97026 2.70711L9.76658 5.50342C10.1571 5.89394 10.1571 6.52711 9.76658 6.91763L7.84261 8.8416C7.528 9.15621 7.45 9.63685 7.64898 10.0348C8.79925 12.3353 10.6647 14.2007 12.9652 15.351C13.3632 15.55 13.8438 15.472 14.1584 15.1574L16.0824 13.2334C16.4729 12.8429 17.1061 12.8429 17.4966 13.2334L20.2929 16.0297C20.6834 16.4203 20.6834 17.0534 20.2929 17.4439L19.4165 18.3204C17.3051 20.4317 13.9625 20.6693 11.5738 18.8777L9.94436 17.6556C8.20083 16.348 6.65201 14.7992 5.34436 13.0556L4.12226 11.4262C2.33072 9.03745 2.56827 5.69488 4.67963 3.58353Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcWhitePhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-white-phone.e84b4cdd64cf9684722b1747d624f661.svg";